import { TabsProps } from 'antd';

export const getTabs = (isDisabled: boolean): TabsProps['items'] => {
    return [
        {
            label: 'Основное',
            key: 'main',
        },
        {
            label: 'Приветственное сообщение',
            key: 'welcome-message',
            disabled: isDisabled,
        },
    ];
};
